import React, { useEffect, useState } from "react";
import MetaData from "../layout/MetaData";
import { useSelector, useDispatch } from "react-redux";
import { calculateOrderCost } from "../../helpers/helpers";
import { useCreateNewOrderMutation } from "../../redux/api/bookingApi";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { clearUserAddressInfo, clearVehicleName, clearLabour, clearGoogleMap, clearGoodsInfo } from "../../redux/features/userAddressInfoSlice";

const ConfirmRide = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [method, setMethod] = useState("COD");

  const { userAddressInfo, vehicleName, labour, googleMap, goodsInfo } = useSelector((state) => state.userAddressInfo);
  const [createNewOrder, { isLoading, error, isSuccess }] = useCreateNewOrderMutation();

  useEffect(() => {
    if (error) toast.error(error?.data?.message);
    if (isSuccess) navigate("/me/bookings");
  }, [error, isSuccess, navigate]);

  const submitHandler = (e) => {
    e.preventDefault();
    const distance = googleMap?.distance ? parseFloat(googleMap.distance.replace(/[^\d.]/g, '')) : 0;
    const vehicle = userAddressInfo?.vehicle;
    const { totalAmount } = calculateOrderCost(distance, vehicle);

    if (method === "COD") {
      const orderData = { orderItems: vehicleName, userAddressInfo, labour, googleMap, totalAmount, goodsInfo, paymentMethod: "COD" };
      createNewOrder(orderData);
      dispatch(clearUserAddressInfo());
      dispatch(clearVehicleName());
      dispatch(clearLabour());
      dispatch(clearGoogleMap());
      dispatch(clearGoodsInfo());
    }
  };

  return (
    <>
      <MetaData title="Payment Method" />
      <div className="row wrapper">
        <div className="col-10 col-lg-5">
          <form className="shadow rounded bg-body" onSubmit={submitHandler}>
            <h2 className="mb-4 text-center">Select Payment Method</h2>

            <div className="mb-4">
              <div className="card p-3">
                <div className="form-check">
                  <input className="form-check-input" type="radio" name="payment_mode" id="codradio" value="COD" checked={method === "COD"} onChange={(e) => setMethod("COD")} />
                  <label className="form-check-label fw-semibold" htmlFor="codradio">Cash on Delivery</label>
                </div>
              </div>
            </div>

            <button id="shipping_btn" type="submit" className="btn btn-primary w-100 py-3 fw-bold" disabled={isLoading}>
              {isLoading ? "Processing..." : "Confirm Order"}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default ConfirmRide;